export default class SatisfactionFormsFill {
  constructor() {
    this.isTemplateForm = this.detectTemplateForm();
    this.bindEvents();
    this.initializeRatings();
    this.initializeConditionalFields();
    
    if (!this.isTemplateForm) {
      this.setDefaultRecommendation();
    }
    
    this.checkFormValidity();
  }

  detectTemplateForm() {
    return $('.dynamic-form-fields').length > 0;
  }

  bindEvents() {
    this.bindStarRatingEvents();
    this.bindYesNoEvents();
    this.bindFormEvents();
  }

  bindStarRatingEvents() {
    $('.star-rating').each((index, ratingContainer) => {
      const $ratingContainer = $(ratingContainer);
      const $stars = $ratingContainer.find('.star');
      const $hiddenInput = $ratingContainer.find('.star-rating-value');

      $stars.on('click', (event) => {
        const value = Number.parseInt($(event.target).closest('.star').data('value'), 10);
        $hiddenInput.val(value);
        this.updateStars($ratingContainer, value);
        this.checkFormValidity();
      });

      $stars.on('mouseenter', (event) => {
        const value = Number.parseInt($(event.target).closest('.star').data('value'), 10);
        this.highlightStars($ratingContainer, value);
      });

      $stars.on('mouseleave', () => {
        const currentValue = Number.parseInt($hiddenInput.val(), 10) || 0;
        this.updateStars($ratingContainer, currentValue);
      });
    });
  }

  bindYesNoEvents() {
    // Handle yes/no field changes for conditional logic
    $('.yes-no-input').on('change', (event) => {
      const $input = $(event.target);
      const fieldKey = $input.closest('.yes-no-field').data('field-key');
      const value = $input.val();
      
      this.updateConditionalFields(fieldKey, value);
      this.checkFormValidity();
    });

    // Legacy recommendation field
    $('input[name="satisfaction_form[would_recommend]"]').on('change', () => {
      this.checkFormValidity();
    });
  }

  bindFormEvents() {
    $('form').on('input change', () => {
      this.checkFormValidity();
    });

    $('form').on('submit', (e) => {
      if (!this.validateForm()) {
        e.preventDefault();
        alert('Veuillez remplir tous les champs obligatoires.');
      }
    });
  }

  initializeRatings() {
    $('.star-rating').each((index, ratingContainer) => {
      const $ratingContainer = $(ratingContainer);
      const $hiddenInput = $ratingContainer.find('.star-rating-value');
      const currentValue = Number.parseInt($hiddenInput.val(), 10) || 0;
      if (currentValue > 0) {
        this.updateStars($ratingContainer, currentValue);
      }
    });
  }

  initializeConditionalFields() {
    // Initialize visibility of conditional fields based on current parent values
    $('.yes-no-input:checked').each((index, input) => {
      const $input = $(input);
      const fieldKey = $input.closest('.yes-no-field').data('field-key');
      const value = $input.val();
      this.updateConditionalFields(fieldKey, value);
    });
  }

  updateConditionalFields(parentFieldKey, parentValue) {
    // Find all child fields that depend on this parent
    $(`.dynamic-field[data-parent-field="${parentFieldKey}"]`).each((index, field) => {
      const $field = $(field);
      const showOn = $field.data('show-on');
      
      if (showOn === parentValue) {
        $field.slideDown(200);
        // Add required back if the field is required
        if ($field.data('required')) {
          const fieldType = $field.data('field-type');
          if (fieldType === 'stars') {
            $field.find('.star-rating-value').attr('data-required', 'true');
          } else if (fieldType === 'yes_no') {
            $field.find('input[type="radio"][value="yes"]').attr('required', 'required');
          } else if (fieldType === 'radio') {
            $field.find('input[type="radio"]:first').attr('required', 'required');
          } else {
            $field.find('input, select, textarea').attr('required', 'required');
          }
        }
      } else {
        $field.slideUp(200);
        // Remove required attributes for hidden fields
        $field.find('[required]').removeAttr('required');
        $field.find('.star-rating-value').removeAttr('data-required');
        // Clear values of hidden fields
        this.clearFieldValue($field);
      }
    });
  }

  clearFieldValue($field) {
    $field.find('input:not([type="radio"]):not([type="hidden"])').val('');
    $field.find('textarea').val('');
    $field.find('select').val('');
    $field.find('input[type="radio"]').prop('checked', false);
    
    // Clear star rating
    const $starRating = $field.find('.star-rating');
    if ($starRating.length > 0) {
      $starRating.find('.star-rating-value').val('');
      this.updateStars($starRating, 0);
    }
  }

  updateStars($container, value) {
    const $stars = $container.find('.star');
    $stars.each((index, star) => {
      const $icon = $(star).find('i');
      if (index < value) {
        $icon.removeClass('mdi-star-outline text-muted').addClass('mdi-star text-warning');
      } else {
        $icon.removeClass('mdi-star text-warning').addClass('mdi-star-outline text-muted');
      }
    });
  }

  highlightStars($container, value) {
    const $stars = $container.find('.star');
    $stars.each((index, star) => {
      const $icon = $(star).find('i');
      if (index < value) {
        $icon.removeClass('mdi-star-outline text-muted').addClass('mdi-star text-warning');
      } else {
        $icon.removeClass('mdi-star text-warning').addClass('mdi-star-outline text-muted');
      }
    });
  }

  setDefaultRecommendation() {
    if (!$('input[name="satisfaction_form[would_recommend]"]:checked').length) {
      $('#would_recommend_yes').prop('checked', true);
    }
  }

  checkFormValidity() {
    const isValid = this.validateForm();
    $('button[type="submit"]').prop('disabled', !isValid);
  }

  validateForm() {
    if (this.isTemplateForm) {
      return this.validateTemplateForm();
    }
    return this.validateLegacyForm();
  }

  validateTemplateForm() {
    let isValid = true;

    // Validate visible required star ratings
    $('.dynamic-field:visible .star-rating-value[data-required="true"]').each((index, input) => {
      const val = Number.parseInt($(input).val(), 10);
      if (Number.isNaN(val) || val <= 0) {
        isValid = false;
        return false;
      }
    });

    // Validate visible required inputs
    $('.dynamic-field:visible input[required]:not(:disabled), .dynamic-field:visible textarea[required]:not(:disabled), .dynamic-field:visible select[required]:not(:disabled)').each((index, input) => {
      const $input = $(input);
      if ($input.attr('type') === 'radio') {
        const name = $input.attr('name');
        if (!$(`input[name="${name}"]:checked`).length) {
          isValid = false;
          return false;
        }
      } else if ($input.val().trim() === '') {
        isValid = false;
        return false;
      }
    });

    // Validate customer info fields if present
    isValid = isValid && this.validateCustomerInfoFields();

    return isValid;
  }

  validateLegacyForm() {
    let starsValid = true;
    $('.star-rating-value').each((index, input) => {
      const val = Number.parseInt($(input).val(), 10);
      if (Number.isNaN(val) || val <= 0) {
        starsValid = false;
        return false;
      }
    });

    const radioChecked = $('input[name="satisfaction_form[would_recommend]"]:checked').length > 0;
    const reasonFilled = $('#satisfaction_form_recommendation_reason').length ? $('#satisfaction_form_recommendation_reason').val().trim() !== '' : true;
    const commentsFilled = $('#satisfaction_form_comments_suggestions').length ? $('#satisfaction_form_comments_suggestions').val().trim() !== '' : true;
    const functionFilled = $('#satisfaction_form_customer_function').length ? $('#satisfaction_form_customer_function').val().trim() !== '' : true;

    const anonymousValid = this.validateCustomerInfoFields();

    return starsValid && radioChecked && reasonFilled && commentsFilled && functionFilled && anonymousValid;
  }

  validateCustomerInfoFields() {
    const anonymousFirstName = $('#satisfaction_form_anonymous_first_name');
    const anonymousLastName = $('#satisfaction_form_anonymous_last_name');
    const anonymousCompanyName = $('#satisfaction_form_anonymous_company_name');

    if (anonymousFirstName.length) {
      return anonymousFirstName.val() && anonymousFirstName.val().trim() !== '' &&
             anonymousLastName.val() && anonymousLastName.val().trim() !== '' &&
             anonymousCompanyName.val() && anonymousCompanyName.val().trim() !== '';
    }
    return true;
  }

  onDataChanged(data) {
  }

  onDestroy() {
  }
}
